<template>
  <div class="view my-view has-footer">
    <HeaderBar />
    <div class="view__wrap">
      <div class="top-bg"></div>
    <My v-bind="profile" :editable="true" />
    <div class="oper-wrap">
      <div class="title">我的账号</div>
      <div class="oper-item-list">
        <router-link class="oper-item" to="/my/wallet">
          <img class="oper-item__icon" src="../../assets/images/wallet.png" />
          <span>{{ `友绿币:${coins}` }}</span>
        </router-link>
        <router-link class="oper-item" to="/my/order">
          <img class="oper-item__icon" src="../../assets/images/order.png" />
          <span>我的订单</span>
        </router-link>
        <router-link class="oper-item" to="/open">
          <img
            class="oper-item__icon vip-img"
            src="../../assets/images/vip_small.png"
          />
          <span v-if="is_vip===1">已开通VIP</span>
          <span v-else-if="is_vip===2">已开通VIP</span>
          <span v-else>未开通VIP</span>

        </router-link>
      </div>
    </div>
    <div class="oper-wrap">
      <div class="title">我的学习</div>
      <div class="oper-item-list">
        <router-link class="oper-item" to="/my/favorite">
          <img class="oper-item__icon" src="../../assets/images/fav.png" />
          <span>内容收藏</span>
        </router-link>

        <router-link class="oper-item" to="/my/history">
          <img class="oper-item__icon" src="../../assets/images/recent.png" />
          <span>最近阅读</span>
        </router-link>
        <router-link class="oper-item" to="/my/learning">
          <img style="padding-top:4px;margin-bottom:5px;"
            class="oper-item__icon" 
            src="../../assets/images/achievement.png"
          />
          <span>学习成就</span>
        </router-link>
      </div>
    </div>
    <div class="menu-list">
      <router-link to="my/following">
        <div class="menu-item">
          <div class="left">
            <img class="menu-img" src="../../assets/images/follow.png" />
            <span class="menu-text">我的关注</span>
          </div>
          <div class="right">
            <img class="forward-img" src="../../assets/images/forward_small.png"/>
          </div>
        </div>
      </router-link>
      <router-link to="my/message">
        <div class="menu-item">
          <div class="left">
            <img class="menu-img" src="../../assets/images/message.png" />
            <span class="menu-text">消息通知</span>
          </div>
          <div class="right">
            <span class="unread-text" v-if="unread_msg>0">{{`${unread_msg}条未读消息`}}</span>
            <img class="forward-img" src="../../assets/images/forward_small.png"/>            
          </div>
        </div>
      </router-link>
<!--      <router-link :to="{path:'/share',query:{hasHeader:1}}">-->
        <div class="menu-item" @click="myShare">
          <div class="left">
            <img class="menu-img" src="../../assets/images/share_big.png" />
            <span class="menu-text">邀请好友</span>
          </div>
          <div class="right">
            <img class="forward-img" src="../../assets/images/forward_small.png"/>
          </div>
        </div>
<!--      </router-link>-->
      <router-link to="my/setting">
        <div class="menu-item">
          <div class="left">
            <img class="menu-img" src="../../assets/images/setting.png" />
            <span class="menu-text">安全设置</span>
          </div>
          <div class="right">
            <img class="forward-img" src="../../assets/images/forward_small.png"/>
          </div>
        </div>
      </router-link>
      <div class="menu-item" @click="checkUpdate">
          <div class="left">
             <img class="menu-img" src="../../assets/images/update.png" />
            <span class="menu-text">版本更新</span>
          </div>
          <div class="right">
            <span class="menutext-left" v-show="hasnew">有更新</span>
            <img class="forward-img" src="../../assets/images/forward_small.png"/>
          </div>

        </div>
      <router-link to="my/feedback">
        <div class="menu-item">
          <div class="left">
            <img class="menu-img" src="../../assets/images/feedback.png" />
            <span class="menu-text">意见反馈</span>
          </div>
          <div class="right">
            <img class="forward-img" src="../../assets/images/forward_small.png"/>
          </div>
        </div>
      </router-link>
      <router-link to="/about">
        <div class="menu-item">
          <div class="left">
            <img class="menu-img" src="../../assets/images/about.png" />
          <span class="menu-text">关于友绿</span>
          </div>
          <div class="right">
            <img class="forward-img" src="../../assets/images/forward_small.png"/>
          </div>
        </div>
      </router-link>
<!--      <router-link to="my/update">-->
        
<!--      </router-link>-->
      
      
    </div>
    </div>
    
    <SharePanel v-show="shareVisible" @cancel="shareVisible = false;" :contentType="3" :hasShare="false" :dataType="4" />
  </div>
</template>
<script>
import { Toast } from 'mint-ui';
import { Button, Dialog } from 'vant';
import SharePanel from '../../components/SharePanel.vue'
import apiUtil from '../../utils/apiUtil';
import apiConst from '../../consts/apiConst';
import My from '../../components/NameCard';
import HeaderBar from '../../components/HeaderBar';
export default {
  name: 'vip',
  components: {
    'van-button': Button,
    My,
    HeaderBar,
    SharePanel
  },
  data() {
    return {
      profile: {},
      coins: '0',
      is_vip: 0,
      unread_msg: 0,
      hasnew:false,
      shareVisible:false
    };
  },
  created() {
    this.initView();
  },
  mounted(){
    window.HostApp.isNewVersion('initCheckVersion');
    window.initCheckVersion = this.initCheckVersion;
  },
  methods: {
    async initView() {
      const res = await apiUtil.post(apiConst.getProfile, {});
      if (res) {
        const { integration, is_vip,unread_msg } = res;
        this.coins = integration == 0 ? 0 : integration;
        this.is_vip = is_vip;
        this.unread_msg = unread_msg;
      }
    },
    checkUpdate(){
      if(this.hasnew){
        window.HostApp.checkVersion();
      }else{
        Toast("暂无更新！")
      }

    },
    initCheckVersion(result){
      if(result=='yes'){
        this.hasnew = true;
      }else{
        this.hasnew = false;
      }
    },
    myShare(){
      this.shareVisible = true;
    }
  }
};
</script>
<style lang="stylus" scoped>
.my-view {
  height: 100%;
	


  .view__wrap{
    display: flex;
	flex-direction: column;
	align-items: center;
    .top-bg{
    position: absolute;
    left: 0;
   /* top: 88px; */
    z-index: -1;
    width: 100%;
    height:200px;
    background:linear-gradient(180deg,rgba(231,231,231,1) 0%,rgba(255,255,255,1) 100%);
    border-radius:0px 0px 100px 100px;
  }
  .name-card-comp {
    flex: none;
    margin-top: 41px;
    margin-bottom: 22px;
  }
	.oper-wrap {
    flex: none;
    margin-bottom: 22px;
		width: 680px;
		height: 180px;
		background-color: rgba(255, 255, 255, 1);
		box-shadow: 0px 18px 26px -16px rgba(189, 202, 217, 1);
		border-radius: 10px;
		border: 1px solid rgba(241, 241, 241, 1);
    .title {
      height: 48px;
      line-height: 48px;
      border-bottom: 1px solid #f1f1f1;
      text-align: center;
      font-size: 20px;
      font-weight: bold;
    }
    .oper-item-list{
      display: flex;
      align-items center;
      .oper-item {
        color: #000
        .oper-item__icon {
          display: block;
          width: 48px;
          // height: 48px;
          margin: 20px auto;

          &.vip-img{
            width: 42px
            height: 42px
          }
        }

        flex: 1;
        text-align: center;
        font-size: 20px;
      }
    }
	}

  .menu-list {
    width: 650px;
    .menu-item {
      height: 88px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1px solid #f1f1f1;

      .left{
        display: flex;
        align-items: center;
        .menu-img {
          display: inline-block;
          flex: 0 0 42px;
          width: 42px;
          height: 42px;
        }

        .menu-text{
          flex: 1;
          line-height: 88px;
          padding-left: 28px;
          color: #666;
        }
      }

      .right {
        display: flex;
        align-items: center;
        .menutext-left{
          // display:inline-block;
          // line-height 88px;
          // border-bottom: 1px solid #f1f1f1;
          color: #108FE7;
          margin-right: 20px;
        }

        .unread-text {
          margin-right: 20px;
          color: #108FE7
        }

        .forward-img{
          width: 30px
          height: 30px;
        }
      }

      
      
    }
  }
  }

  
}
</style>
